__turbopack_context__.v({
  "container": "marketplace-purchase-content-module-scss-module__IqcAPG__container",
  "separator": "marketplace-purchase-content-module-scss-module__IqcAPG__separator",
  "skeleton": "marketplace-purchase-content-module-scss-module__IqcAPG__skeleton",
});
